import { useQuery } from '@tanstack/react-query';
import useApi from '../../../../../../../utils/AxiosWrapper';
import { useIsPreActiveCustomer } from '../../../../../../../hooks/useIsPreActiveCustomer';
import { useUser } from '../../../../../../../utils/UserContext';
import { CustomerWithDriverOnboarding } from '../../../../../../../types/apiTypes';
import { getDemoReportPacks } from '../demoAccountingData';

export function useReportPacks(customerId: string) {
  const { callProtectedApi } = useApi();
  const { userRecord } = useUser();
  const isPreActive = useIsPreActiveCustomer();
  const businessType = (userRecord as CustomerWithDriverOnboarding | null)
    ?.business_type;

  return useQuery({
    queryKey: ['accounting-report-packs', customerId],
    queryFn: async () => {
      const response = await callProtectedApi(
        `/accounting/${customerId}/report-packs`,
        'get'
      );
      return response?.data?.data;
    },
    // See useIncomeStatement — demo data for pre-active, no request fired, and
    // placeholder rather than initial so it never enters the cache. Demo packs
    // are always `ready`, and placeholder data isn't in `query.state.data`, so
    // the poll below stays off either way.
    enabled: !!customerId && !isPreActive,
    placeholderData: isPreActive
      ? () => getDemoReportPacks(businessType)
      : undefined,
    refetchInterval: (query) => {
      const packs = query.state.data as Array<{ status: string }> | undefined;
      if (
        Array.isArray(packs) &&
        packs.some((pack) => pack.status === 'generating')
      ) {
        return 3000;
      }
      return false;
    },
  });
}
